import React from 'react';
import { Typography, Link } from '@mui/material';
import Box from '@mui/material/Box';
import { I18n } from 'utils/i18n';
import { Link as RouterLink } from 'react-router';

const NoInvitationHeading = () => (
  <Box component="section">
    <div>
      <Typography sx={{ maxWidth: 290 }} gutterBottom variant="h5">
        {I18n.t('NoInvitation.headline')}
      </Typography>
      <Typography variant="h5" sx={{ color: '#8b98ab', fontWeight: 'normal' }}>
        {I18n.t('NoInvitation.subheading')}
      </Typography>
    </div>
    <Box
      component="hr"
      sx={theme => ({
        m: '40px 0',
        border: '1px solid',
        borderColor: theme.palette.divider,
      })}
    />
    <Box sx={{ pb: '20px' }}>
      <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
        {I18n.t('NoInvitation.no invitation')}
      </Typography>
      <Typography variant="caption">
        <Link
          component={RouterLink}
          to="/auth/login-no-invitation/form"
          sx={{ color: 'primary.dark' }}
        >
          {I18n.t('NoInvitation.click here')}{' '}
        </Link>
        {I18n.t('NoInvitation.fill the form')}
      </Typography>
    </Box>
  </Box>
);

export default NoInvitationHeading;
